import React from "react";

import { useTranslation } from "react-i18next";

import Header from "../../contruction-home/components/Header";
import Footer from "../../contruction-home/components/Footer";
import Hero from "../../contruction-home/components/Hero";
import QuoteForm from "./QuoteForm";
import NormalUserLayout from "../../layouts/NormalUserLayout/NormalUserLayout";

const Job = () => {
  const { t } = useTranslation();

  return (
    <div className="ConstructionHome">
      <NormalUserLayout>
        <Header />
        <main className="main">
          {/* <div style={{ background: "rgba(0, 0, 0, 1)" }}> */}
          <Hero compact />
          <section id="get-started" className="get-started section">
            <div className="container">
              <div className="row justify-content-between gy-4">
                <div
                  className="col-12 col-lg-6 d-flex align-items-center"
                  data-aos="zoom-out"
                  data-aos-delay="100"
                >
                  <div className="content">
                    <h3>{t("Job.heading")}</h3>
                    <p>{t("Job.desc1")}</p>
                    <p>{t("Job.desc2")}</p>
                    <ul className="list-unstyled">
                      <li>{t("Job.desc3")}</li>
                      <li>{t("Job.desc4")}</li>
                      <li>{t("Job.desc5")}</li>
                      <li>{t("Job.desc6")}</li>
                    </ul>
                    <p>{t("Job.desc7")}</p>
                    <p>{t("Job.desc8")}</p>
                    <p>{t("Job.desc9")}</p>
                  </div>
                </div>

                <div className="col-12 col-lg-5" data-aos="zoom-out" data-aos-delay="200">
                  <QuoteForm ns="Job" />
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </NormalUserLayout>
    </div>
  );
};

export default Job;
